
import { useCrudMutations } from './mutations/useCrudMutations';
import { useToggleMutation } from './mutations/useToggleMutation';
import { useProcessMutation } from './mutations/useProcessMutation';

export const useMutations = (resetForm: () => void, setIsDialogOpen: (open: boolean) => void) => {
  const { addUpdateMutation, updateMutation, deleteMutation } = useCrudMutations(resetForm, setIsDialogOpen);
  const { toggleActiveMutation } = useToggleMutation();
  const { processUpdatesMutation } = useProcessMutation();

  return {
    addUpdateMutation,
    updateMutation,
    deleteMutation,
    toggleActiveMutation,
    processUpdatesMutation
  };
};
